"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorCheckboxWrapper = exports.StyledDisabledCheckboxWrapper = exports.StyledMasterRadioButtonWrapper = exports.StyledInputRadioButton = exports.StyledMessageStatus = exports.StyledRadioButtonWrapper = exports.StyledLabelRadioButton = exports.StyledFilledContentRadionButton = exports.StyledCircleRadioButton = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
const typography_1 = require("../typography");
const utils_1 = require("./utils");
exports.StyledCircleRadioButton = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  width: ${theme_1.spacings.s4};
  height: ${theme_1.spacings.s4};
  background-color: ${theme_1.grayScale[50]};
  padding: ${theme_1.spacings.s0};
  border: ${theme_1.spacings.s0} solid ${theme_1.grayScale[600]};
  border-radius: 50%;
  transition: color 0.3s;
  align-items: center;
  justify-content: center;
`;
exports.StyledFilledContentRadionButton = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  background-color: ${theme_1.grayScale[50]};
  border-radius: 50%;
`;
exports.StyledLabelRadioButton = (0, styled_components_1.default)(typography_1.Typography) `
  cursor: pointer;
  line-height: ${theme_1.spacings.s5};
  color: ${theme_1.grayScale[900]};
`;
exports.StyledRadioButtonWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  gap: ${theme_1.spacings.s3};
`;
exports.StyledMessageStatus = (0, styled_components_1.default)(typography_1.Typography) `
  color: ${theme_1.grayScale[600]};
  line-height: ${theme_1.spacings.s5};
  font-weight: 500;
`;
exports.StyledInputRadioButton = styled_components_1.default.input `
  overflow: hidden;
  white-space: nowrap;
  width: 0;
  height: 0;
  background-color: transparent;
  margin: -1px;
  padding: 0;
  border: 0;
  outline: 0;
`;
exports.StyledMasterRadioButtonWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${(props) => {
    return (0, styled_components_1.css) `
      width: max-content;
      gap: ${theme_1.spacings.s3};
      cursor: pointer;
      transition: color 0.3s;
      padding: ${theme_1.spacings.s1};
      & * {
        transition: all 0.3s;
      }

      ${exports.StyledRadioButtonWrapper} {
        &:hover {
          ${(0, utils_1.GetLabelHoverStyles)(props)}
        }
      }

      &:focus-visible,
      &:focus-within {
        border: 2px solid ${theme_1.primary.dark};
        box-shadow: ${theme_1.shadows.containedFocus(theme_1.primary.dark, theme_1.primary.dark)};
        border-radius: ${theme_1.spacings.s2};

        ${(0, utils_1.GetLabelHoverStyles)(props)}
      }

      ${(0, utils_1.GetRadioButtonActiveStyles)(props)}
    `;
}}
`;
exports.StyledDisabledCheckboxWrapper = (0, styled_components_1.default)(exports.StyledMasterRadioButtonWrapper) `
  ${() => {
    const disabledStyles = (0, styled_components_1.css) `
      ${exports.StyledCircleRadioButton} {
        background-color: ${theme_1.grayScale[50]};
        border-color: ${theme_1.grayScale[400]};
      }

      ${exports.StyledMessageStatus} {
        display: none;
      }

      ${exports.StyledFilledContentRadionButton} {
        background-color: ${theme_1.grayScale[50]};
      }
    `;
    return (0, styled_components_1.css) `
      ${disabledStyles}
      &:hover {
        ${disabledStyles}
        cursor: not-allowed;
      }
    `;
}}
`;
exports.StyledErrorCheckboxWrapper = (0, styled_components_1.default)(exports.StyledMasterRadioButtonWrapper) `
  ${() => {
    const disabledStyles = (0, styled_components_1.css) `
      ${exports.StyledCircleRadioButton} {
        border-color: ${theme_1.system.error};
      }

      ${exports.StyledMessageStatus} {
        color: ${theme_1.system.error};
      }
    `;
    return (0, styled_components_1.css) `
      ${disabledStyles}
      &:hover {
        ${disabledStyles}
      }
    `;
}}
`;
//# sourceMappingURL=styles.js.map